import { getBaseUrl } from './ServiceUtils';
import appRequest from './appRequest';

const HYDRA_URL = getBaseUrl('/hydra/');

// Reinicia o processo do backend (pm2 ressuscita). Admin-only no servidor.
export async function restartBackend() {
    return await appRequest.doPostRequest(`${HYDRA_URL}restart`, {});
}
